<template>
<header id="pageTop" class="header">
		<!-- NAVBAR -->
		<nav class="navbar navbar-expand-md main-nav">
			<div class="container">
				<button class="navbar-toggler  navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
					<span class="burger-menu icon-toggle"><i class="fa fa-bars"></i></span>
				</button>
				<a class="" href="index.html">
					<img class="logo-fill-2" src="/src/assets/img/Logo-Americana-Negocios.png" alt="Americana" width="302px" height="54px">
				</a>
				<div class="collapse navbar-collapse" id="navbarSupportedContent">
					<ul class="navbar-nav ml-auto scrolling">
						<li class="nav-item">
							<a class="nav-link" href="#main-slider">INICIO</a>
						</li>
						<li class="nav-item ">
							<a class="nav-link" href="#about">ACERCA DE NOSOTROS</a>
						</li>
						<li class="nav-item ">
							<a class="nav-link" href="#service">SERVICIOS</a>
						</li>
						<li class="nav-item ">
							<a class="nav-link" href="#products">CERTIFICACIONES</a>
						</li>
						<li class="nav-item ">
							<a class="nav-link" href="#contactus">CONTACTO</a>
						</li>
					</ul>
				</div>
				<div class="nav-cart">
					<a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a>
				</div>
				<div class="nav-cart">
					<a href="#"><i class="fa fa-twitter" aria-hidden="true"></i></a>
				</div>
				<div class="nav-cart">
					<a href="#"><i class="fa fa-instagram" aria-hidden="true"></i></a>
				</div>
			</div>
		</nav>
	</header>
</template>

<script>
export default {
  name: 'MainMenu',
  data() {
    return {
    }
  },
  created() {
  },
  methods:{
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.boxed .main-nav .nav-item a.nav-link {
	color:black
}
</style>



// WEBPACK FOOTER //
// src/components/menu/MainMenu.vue